import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import moment from 'moment-timezone';
import '../../styles/common.scss';
import './index.scss';
// import InfluxMovies from "../../assets/images/movies/Influx-movies-logo.svg";
import * as API from '../../configuration/apiconfig';
import Loader from '../loader';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ReactComponent as IconAllExperiences } from '../../assets/images/icons/iconAllExperiences.svg';
import { calculateHoursAndMinutes, formatCurrentTime, formatShowTime } from '../../utils/DateTimeFormat';
import { ReactComponent as ClockIcon } from '../../assets/images/clockIcon_black.svg';
import { ReactComponent as ResetIcon } from '../../assets/images/resetIcon.svg';
import { ReactComponent as CloseIcon } from '../../assets/images/closeIcon.svg';
import { ReactComponent as AlertIcon } from '../../assets/images/Alert.svg';
import { filterPackImageBasedOnImageCode, filterImageBasedOnImageCode } from '../../utils/FilterImages';
import Slider from 'react-slick';
import Modal from 'react-bootstrap/Modal';
import Header from '../../components/Header';
import { ReactComponent as NoShowIcon } from '../../assets/images/icons/noShowsIcon.svg';
var setTime;
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      allFilms: [],
      nowShowingData: [],
      movies: [],
      currentDate: new Date(),
      heroBannerImages: [],
      showExperienceModal: false,
      experienceModalWidth: 0,
      experienceModalWidth: 0,
      allExperiences: [],
      selectedExperiences: [],
      clickedExperiences: [],
      nextShowTimes: [],
      cinemaData: [],
      experiencesFromCinema: [],
    };
  }

  componentDidMount = async () => {
    await this.getCinemaData(localStorage.getItem('cinemaid'));
    await this.getFilms();
    var heroBannerSource = window.constant.MOVIES_PAGE_HEROBANNER_SOURCE;
    if (heroBannerSource.includes('https') || heroBannerSource.includes('http')) {
      this.setState({
        heroBannerImages: heroBannerSource.split(','),
      });
    } else {
      API.callEndpoint('GET', 'Bearer', '/cms/v2/packs/' + heroBannerSource).then(response => {
        var heroBannerImages = filterPackImageBasedOnImageCode(response, window.constant.MOVIES_PAGE_HEROBANNER_IMAGECODE);
        this.setState({ heroBannerImages }, () => {});
      });
    }
    localStorage.removeItem('sesstionid');
    localStorage.removeItem('selectedmoviename');
    localStorage.removeItem('sessionExpiredRedirectUrl');
    localStorage.removeItem('endTimeInSecs');
    localStorage.removeItem('BookingCountdown');
    var self = this;
    setTime = setInterval(() => {
      if (self.state.currentDate != new Date()) {
        self.setState({
          currentDate: new Date(),
        });
      }
    }, 2000);
  };

  componentDidUpdate = () => {
    var modalBody = document.getElementById('modalBody');
    if (modalBody != null) {
      if (modalBody.offsetWidth != this.state.experienceModalWidth) {
        this.setState({
          experienceModalWidth: modalBody.offsetWidth,
        });
      }
    }
  };

  componentWillUnmount() {
    clearInterval(setTime);
  }

  getCinemaData = async cinemaId => {
    API.callEndpoint('GET', 'Bearer', '/cms/v2/cinemas?id=' + cinemaId)
      .then(response => {
        this.setState(
          {
            cinemaData: response.data[0],
          },
          () => {
            console.log('getCinemaData() > this.state.cinemaData:', this.state.cinemaData);
            this.getAllExperiences();
            this.getNextShowTimes();
          }
        );
      })
      .catch(ex => {
        console.log(ex.error);
      });
  };

  getFilms = async () => {
    this.setState({
      loader: true,
    });
    const films = await API.callEndpoint('GET', 'Bearer', '/cms/v2/films');
    // console.log(films, 'films');
    this.setState(
      {
        allFilms: films.data,
      },
      () => {
        this.getNowshowing();
      }
    );
  };

  getNowshowing = () => {
    this.setState(
      {
        loader: true,
      },
      () => {
        var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
        var nowShowingURL = '';
        if (getCinemaIdFromLocalstorage) {
          nowShowingURL = `/cms/v2/packs/scheduledshowtimes?cinemaid=${getCinemaIdFromLocalstorage}`;
        } else {
          nowShowingURL = `/cms/v2/packs/scheduledshowtimes`;
        }
        API.callEndpoint('GET', 'Bearer', nowShowingURL).then(response => {
          this.setState(
            {
              nowShowingData: response.data[0],
              loader: false,
            },
            () => {
              this.showMovies();
            }
          );
        });
      }
    );
  };

  showMovies = () => {
    var tempAllFilms = this.state.allFilms;
    var tempNowShowingData = this.state.nowShowingData;

    if (tempNowShowingData !== undefined && Object.keys(tempNowShowingData).length > 0 && tempNowShowingData.packs_films_results.length > 0) {
      var getSortedFilms = [];
      tempNowShowingData.packs_films_results.map(pack => {
        tempAllFilms.map(filmInfo => {
          if (pack.filmid == filmInfo.id) {
            getSortedFilms.push(filmInfo);
          }
        });
      });

      this.setState({
        movies: getSortedFilms,
      });
    }
  };

  moviesRender = () => {
    var tempNowShowingData = this.state.nowShowingData;
    var tempMovies = JSON.parse(JSON.stringify(this.state.movies));
    if (this.state.selectedExperiences.length > 0) {
      var moviesAfterExpFilter = [];
      tempMovies.forEach(movie => {
        const intersection = movie.experiences.filter(element => this.state.selectedExperiences.includes(element));
        if (intersection.length != 0) {
          moviesAfterExpFilter.push(movie);
        }
      });
      tempMovies = moviesAfterExpFilter;
    }

    var renderElem = '';
    {
      tempMovies.length > 0
        ? (renderElem = tempMovies.map((filmsData, index) => {
            const nextShowTime = this.getNextShowTime(filmsData.id, filmsData.experiences);

            return (
              <div key={index} className="movies-list col-3">
                <a onClick={() => this.selectMovieClick(filmsData)} title={filmsData.title}>
                  <div>
                    {filmsData.images.length > 0
                      ? filmsData.images
                          .filter(img => img.code == 'x250y350')
                          .map(({ imageurl }) => {
                            return (
                              <div className="img-blk">
                                <img src={imageurl ? imageurl : ''} className="img-fluid" alt={filmsData.title} />
                              </div>
                            );
                          })
                      : null}
                    <aside className="cont-sec">
                      <h4>{filmsData.title}</h4>
                      <p>
                        {filmsData.rating && <span>{filmsData.rating}</span>}
                        {filmsData.rating && filmsData.runtime && <>&nbsp;-&nbsp;</>}
                        {filmsData.runtime && <span>{calculateHoursAndMinutes(filmsData.runtime)}</span>}
                      </p>
                      <p className="cont-geners-sec">
                        {/* {filmsData.runtime && filmsData.genres.length > 0 && <>&nbsp;-&nbsp;</>} */}
                        {filmsData.genres.map((genresData, index) => {
                          return (
                            <span>
                              {genresData.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())} {filmsData.genres.length - 1 == index ? '' : '/'}{' '}
                            </span>
                          );
                        })}
                      </p>
                    </aside>
                    <div className="mov-det">
                      {filmsData.emblems.length > 0 ? (
                        <aside className="ad-book">
                          <span>{filmsData.emblems[0]}</span>
                        </aside>
                      ) : null}
                    </div>
                  </div>
                  <div className="next-show-details">
                    {nextShowTime && nextShowTime.showTime ? (
                      <>
                        <p>Next Show</p>
                        <div className="show-details">
                          <div className="show-time">{nextShowTime.showTime}</div>
                          <p className="show-experience">{nextShowTime.experience}</p>
                        </div>
                      </>
                    ) : (
                      <div className="no-showtimes">
                        {/* <img src={NoShowIcon} width={26} height={26} alt="no-show-icon"></img> */}
                        <NoShowIcon width={26} height={26} />
                        <p>No Shows Today</p>
                      </div>
                    )}
                  </div>
                </a>
              </div>
            );
          }))
        : (renderElem =
            Object.keys(tempNowShowingData).length > 0 && tempNowShowingData.packs_films_results.length == 0 ? (
              <div className="error-blk">
                <p>Currently there are no movies to be played.</p>
              </div>
            ) : (
              <SkeletonTheme baseColor="#d6d6d6" highlightColor="#ccc">
                <div className="movie-skeletons">
                  <Skeleton count={12} height="400px" width="230px" />
                </div>
              </SkeletonTheme>
            ));
    }

    if (this.state.selectedExperiences.length > 0 && tempMovies.length == 0) {
      renderElem = (
        <div className="no-movies-found">
          {/* <img src={alertIcon}></img> */}
          <AlertIcon />
          <p>No movies found for selected {this.state.selectedExperiences.length > 1 ? 'experiences' : 'experience'}</p>
        </div>
      );
    }

    return renderElem;
  };

  toggleExperienceModal = visibility => {
    if (visibility) {
      this.setState({
        clickedExperiences: [...this.state.selectedExperiences],
      });
    }
    this.setState({ showExperienceModal: visibility });
  };

  getAllExperiences = () => {
    API.callEndpoint('GET', 'Bearer', '/cms/v2/experiences').then(response => {
      // console.log(response.data);
      this.setState(
        {
          allExperiences: response.data,
        },
        async () => {
          let experiencesListFromCinema = this.state.cinemaData.experiences;
          await this.populateExperiencesFromCinemaData(experiencesListFromCinema);
        }
      );
    });
  };

  populateExperiencesFromCinemaData = async experiencesListFromCinema => {
    if (experiencesListFromCinema.length > 0) {
      var populateExperiencesFromCinema = [];
      let allExperiencesFromState = this.state.allExperiences;

      experiencesListFromCinema.map(experienceId => {
        var getExperienceIdIndex = allExperiencesFromState.findIndex(x => experienceId == x.id);
        if (getExperienceIdIndex != -1) {
          populateExperiencesFromCinema.push(this.state.allExperiences[getExperienceIdIndex]);
        }
      });

      this.setState(
        {
          experiencesFromCinema: populateExperiencesFromCinema,
        },
        () => {
          console.log('this.state.experiencesFromCinema: ', this.state.experiencesFromCinema);
        }
      );
    }
  };

  experienceClick = experience => {
    var clickedExperiences = JSON.parse(JSON.stringify(this.state.clickedExperiences));
    var checkIfExperienceExists = clickedExperiences.includes(experience.id);
    if (!checkIfExperienceExists) {
      clickedExperiences.push(experience.id);
    } else {
      clickedExperiences.splice(clickedExperiences.indexOf(experience.id), 1);
    }
    this.setState({ clickedExperiences });
  };

  clearSelectedExperiences = () => {
    this.setState({
      clickedExperiences: [],
    });
  };

  selectMovieClick = getMovie => {
    console.log(getMovie, 'getMovie');
    localStorage.setItem('selectedmoviename', getMovie.urlSafeName);
    window.location.href = `/showtime?title=${getMovie.urlSafeName}`;
  };

  applyExperiences = () => {
    this.setState(
      {
        selectedExperiences: [...this.state.clickedExperiences],
      },
      () => {
        this.toggleExperienceModal(false);
        this.clearSelectedExperiences();
      }
    );
  };

  getNextShowTimes = () => {
    var cinemaData = this.state.cinemaData;
    var currentDates = moment().tz(cinemaData.tz);
    currentDates = currentDates.format().split('T')[0];
    var currentDateArr = currentDates.split('-');
    var date = currentDateArr[0] + '-' + currentDateArr[1] + '-' + currentDateArr[2];
    console.log(date, 'currentDatestr');

    API.callEndpoint('GET', 'Bearer', `/cms/v2/showtimes?showdate=${date}&cinemaid=${cinemaData.id}`).then(response => {
      // console.log(response.data, "response.data get next show times");
      this.setState({
        nextShowTimes: response.data,
      });
    });
  };

  getNextShowTime = filmId => {
    const cinemaid = localStorage.getItem('cinemaid');
    let nextShowTime = { showTime: '', experience: [''] };
    let experiencesId = [];
    let nextShowTimes = this.state.nextShowTimes;
    nextShowTimes = nextShowTimes.filter(showTime => showTime.cinemaid == cinemaid);
    let filmShowTimes = nextShowTimes.filter(showTime => showTime.filmid == filmId);
    let sortNextShowTime = filmShowTimes.sort((a, b) => new Date(a.showtime) - new Date(b.showtime));

    if (sortNextShowTime.length > 0) {
      let showTime = sortNextShowTime[0];
      nextShowTime.showTime = formatShowTime(showTime.showtime);
      experiencesId = [...showTime.experiences];
    }

    // // // // // let experiences = this.state.allExperiences;
    let experiences = this.state.experiencesFromCinema;
    experiences.forEach(experience => {
      experiencesId.forEach(id => {
        if (experience.id == id) {
          nextShowTime.experience.push(experience.name);
        }
      });
    });
    // console.log(nextShowTime, "nextShowTime");
    return nextShowTime;
  };

  render() {
    var { currentDate, heroBannerImages, allExperiences, selectedExperiences, clickedExperiences, experiencesFromCinema } = this.state;
    var settings = {
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      fade: true,
      autoplaySpeed: 5000,
      className: 'slickSlider heroBanner',
      appendDots: dots => <ul>{dots}</ul>,
      customPaging: i => <div className="customDots"></div>,
    };
    return (
      <>
        <Loader loader={this.state.loader} />
        <section
          // className="movie-container"
          className={`movie-container ${this.state.heroBannerImages.length == 0 ? 'noHeroBannerBlock' : ''}`}
        >
          <Header logo={false} homeIcon={true} timer={false} />
          <div className="movie-banner">
            {heroBannerImages.length > 0 && (
              <Slider {...settings}>
                {heroBannerImages.map((image, imageIndex) => {
                  return <img src={image} alt="Muvi banner" style={{ height: 540 }} />;
                })}
              </Slider>
            )}
          </div>
          <div className="op-sec">
            <aside className="timer">
              {/* <img src={clockIcon} alt="Timer" /> */}
              <ClockIcon />
              <p>{formatCurrentTime(currentDate)}</p>
            </aside>
            <aside className="rt-sec">
              {/* <a href="javascript:;" className="filterButton fbPrimary" title="Next 10 SHOWS">
                <img src={IconNext10Shows} alt="Next 10 SHOWS" />
                Next 10 shows
              </a> */}
              <a href="javascript:;" className="filterButton fbSecondary" title="ALL EXPERIENCES" onClick={() => this.toggleExperienceModal(true)}>
                {/* <img src={IconAllExperiences} alt="ALL EXPERIENCES" /> */}
                <IconAllExperiences />
                All Experiences
                {selectedExperiences.length > 0 && <p className="filterCount">{selectedExperiences.length}</p>}
              </a>
            </aside>
          </div>
          <div className="movies-sec">
            <div className="container-fluid">
              <div className="row">{this.moviesRender()}</div>
            </div>
          </div>
          <div className="movies-footer">
            <a target="_blank" title="Powered by influx">
              <span>Powered by</span>
              <img src={'/assets/images/Influx-movies-logo.svg'} alt="Influx" />
            </a>
          </div>
        </section>
        <Modal show={this.state.showExperienceModal} onHide={() => this.toggleExperienceModal(false)} centered id="experienceModal">
          <Modal.Header>
            <button className="closButton" onClick={() => this.toggleExperienceModal(false)}>
              {/* <img src={closeIcon} /> */}
              <CloseIcon />
            </button>
            <Modal.Title className="heading">Filter by Experience</Modal.Title>
          </Modal.Header>
          <Modal.Body id="modalBody" className={experiencesFromCinema.length > 0 ? '' : 'border-bottom-0'}>
            {
              // // // // // allExperiences.length > 0 &&
              // // // // //   allExperiences.map((experience) => {
              experiencesFromCinema.length > 0 ? (
                experiencesFromCinema.map(experience => {
                  return (
                    <div className={`experienceDiv ${clickedExperiences.includes(experience.id) ? 'active' : ''}`} onClick={() => this.experienceClick(experience)}>
                      {/* <img src={filterImageBasedOnImageCode(experience.images, "x200y50").length > 0 ? filterImageBasedOnImageCode(experience.images, "x200y50")[0] : ""}></img> */}
                      <span>{experience.name}</span>
                    </div>
                  );
                })
              ) : (
                <p className="errorMessage">Sorry! Filtering experiences is currently not available</p>
              )
            }
          </Modal.Body>
          {experiencesFromCinema.length > 0 && (
            <Modal.Footer>
              <div className="applyResetDiv" style={{ width: this.state.experienceModalWidth }}>
                <button className="btn btn-primary resetButton" onClick={this.clearSelectedExperiences}>
                  {/* <img src={resetIcon} />  */}
                  <ResetIcon />
                  RESET
                </button>
                <button className="btn btn-primary applyButton" onClick={() => this.applyExperiences()}>
                  APPLY
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </>
    );
  }
}

export default index;
